import { COUNTRIES, STATE_CODES } from 'straightline-utils/constants';
import { strippable, yup } from 'straightline-utils/validation';

const countries = COUNTRIES.map((country) => country.value);

export default (app) => {
  return yup.object({
    name: yup.string().trim().label('Business Name').required(),
    billing_emails: yup
      .array(yup.string().trim().email().required().label('Billing Email'))
      .required()
      .min(1)
      .label('Billing Emails')
      .required(),
    address: yup
      .object({
        city: yup.string().trim().label('City').required(),
        state: yup.string().trim().oneOf(STATE_CODES).label('State').required(),
        country: yup
          .string()
          .trim()
          .oneOf(countries)
          .label('Country')
          .required(),
        postal_code: yup.string().trim().label('Postal Code').required(),
        address_1: yup.string().trim().label('Address 1').required(),
        address_2: strippable(yup.string().trim().label('Address 2').nullable())
      })
      .default(undefined)
      .nullable()
      .label('Address')
  });
};
